import { Col, Row } from "react-bootstrap";

export default function Summary_Scaleless_2({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Compact name styles
  const nameStyle = {
    fontSize: isSub ? "12px" : "14px",
    fontWeight: "600",
    padding: "2px 8px",
    textAlign: "center",
    lineHeight: "1.2",
  };

  return (
    <Row
      style={{
        height: Number(item.height),
        marginBottom: "0",
        padding: "0",
      }}
    >
      <Row className="justify-content-center align-items-center" style={{ margin: "0" }}>
        <Col xs="auto" style={nameStyle}>
          {item.name}
        </Col>
        <Col xs="auto" style={{ padding: "0 4px" }}>
          <div
            className={(!isSub ? "_main-scope-score-header-pdf-detail-new" : "_sub-scope-score-pdf") + " _flex-center"}
          >
            {elementScore}
          </div>
        </Col>
      </Row>
    </Row>
  );
}
